<template>
  <div class="container" style="height: 100%">
    <div class="loader-wrapper" v-if="loading" style="height: 100vh">
      <div class="spinner-border loader" style="width: 4rem; height: 4rem; color: #36a0dd; border-width: 8px" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else style="height: 100%">
      <div class="center-screen" v-if="errorMessage" style="height: 100vh">
        <div class="alert alert-danger" style="width: 100%">
          <h3>{{ errorMessage }}</h3>
        </div>
      </div>
      <div v-else>
        <validation-certificate :data="validationResult" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import ValidationCertificate from '@/components/validation-certificate.vue';

export default {
  components: {
    ValidationCertificate,
  },
  data() {
    return {
      loading: true,
      baseUrlApi: 'https://api.dvgapp.org',
      errorMessage: null,
      validationResult: null,
    };
  },
  created() {
    this.validate();
  },
  methods: {
    async validate() {
      this.errorMessage = null;
      const url_string = window.location.href;
      const url = new URL(url_string);
      const id = url.searchParams.get('id');
      const sha = url.searchParams.get('sha');

      if (!id || !sha) {
        this.loading = false;
        this.errorMessage = 'Invalid URL';
        return;
      }

      const payload = {
        id: id,
        sha: sha,
      };
      await axios
        .post(`${this.baseUrlApi}/healthcheck-restful-api/verification/validate`, payload)
        .then((res) => {
          if (res.status == 200) this.validationResult = res.data;
          else this.validationResult = null;
        })
        .catch((error) => {
          this.validationResult = null;
          console.error(error);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://cdn.jsdelivr.net/npm/bootstrap@5.0.0-beta1/dist/css/bootstrap.min.css');
.loader-wrapper {
  display: flex;
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
}

.center-screen {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
